import React from 'react';

import { P } from '../P/P';

import { Section } from './Section';
import { UL } from './UL';
import { LI } from './LI';
import { ExternalLink } from './ExternalLink';

export const MORE_MATERIAL_AND_TIPS = () => (
  <Section>

    <UL>
      <LI>
        <P gapAfter>
          Bayerischer Rundfunk: Erklärfilm Fast Fashion/Fakten und Zahlen im Überblick. Geeignet als Einführung/zur Relevanz des Themas.<br />
          <ExternalLink href="http://www.br.de/puls/themen/leben/fast-fashion-in-zahlen-102.html" />
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Wanderausstellung Fast Fashion, Schattenseite der Mode:<br />
          <ExternalLink href="http://www.fastfashion-dieausstellung.de" />
          (Bei Redaktionsschluss standen keine Termine in Deutschland fest)
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Ausstellung (Berlin): Fast Fashion – Slow Fashion 27.09.2019 bis 02.08.2020 im Museum Europäischer Kulturen:<br />
          <ExternalLink href="https://www.smb.museum/ausstellungen/detail/fast-fashion-slow-fashion.html">
            https://www.smb.museum&hellip;fast-fashion-slow-fashion.html
          </ExternalLink>
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Bundeszentrale für politische Bildung 2018: Was geht? Modekonsum. Schülermagazin und Begleitheft für Pädagogen.<br />
          <ExternalLink href="https://www.bpb.de/shop/lernen/was-geht/275495/wie-sieht-s-aus-das-heft-ueber-fashion-und-style">
            https://www.bpb.de&hellip;heft-ueber-fashion-und-style
          </ExternalLink>
          , Bestellnummer: 9617
        </P>
      </LI>
      <LI>
        <P gapAfter>
          AKTIV werden: Mit der Initiative MAKE SMTHNG möchte Greenpeace die Maker-Community unterstützen und bietet dafür auch Unterrichtsimpulse mit Hintergrundinformationen zu Fast Fashion:<br />
          <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/gpbm_konsum_shoppen_oder_selbermachen_0.pdf">
            https://www.greenpeace.de&hellip;oder_selbermachen_0.pdf
          </ExternalLink>
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Dokumentationsserie über eine Fashion-Bloggerin aus Norwegen, die in die Textilproduktion eintaucht:<br />
          <ExternalLink href="https://www.aftenposten.no/norge/i/4d1nl9/Video-fra-Aftenposten?category=10514" />
          (OV mit englischen Untertiteln), Bericht in deutscher Sprache hierüber:<br />
          <ExternalLink href="https://www.br.de/puls/themen/leben/deadly-fashion-interview-frida-ottesen-100.html" />
          <br />
          Bemerkung: Die Serie ist gut geeignet, da sich junge Menschen mit der Bloggerin gut identifizieren können. Sie kann aber auch eine sehr aufwühlende Wirkung haben. Suchen Sie sich daher vorher genau aus, welche Folge Sie im Klassenraum zeigen möchten.
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Film &#8222;The true Cost”.&nbsp;
          <ExternalLink href="https://truecostmovie.com/" /><br />
          Wenn es Ihnen nicht möglich ist, den Film zu bestellen/zu zeigen, können Sie viele Informationen aus den begleitenden Materialien ziehen, z. B. Rollenspiel zur Wertschöpfungskette ab Seite 26:<br />
          <ExternalLink href="http://grandfilm.de/wp-content/uploads/2016/03/Schulmaterial_TheTrueCost_DerPreisDerMode.pdf">
            http://grandfilm.de&hellip;TheTrueCost_DerPreisDerMode.pdf
          </ExternalLink>
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Podcast &#8222;Wardrobe Crisis” von Clare Press (Englisch), ggf. zum fächerverbindenden Einsatz:<br />
          <ExternalLink href="https://www.clarepress.com/podcast" />
        </P>
      </LI>
      <LI>
        <P gapAfter>
          &#8222;Das Bündnis für nachhaltige Textilien ist eine Multistakeholder-Initiative mit rund 130 Mitgliedern aus Wirtschaft, Politik und Zivilgesellschaft. Sie wollen gemeinsam die Bedingungen in der weltweiten Textilproduktion verbessern – von der Rohstoffproduktion bis zur Entsorgung. Das Textilbündnis wurde im Oktober 2014 als Antwort auf tödliche Unfälle in Textilfabriken in Bangladesch und Pakistan gegründet. Initiator war Bundesentwicklungsminister Dr. Gerd Müller. Die Mitglieder des Textilbündnisses decken heute rund die Hälfte des deutschen Textilmarktes ab. Eine Marktabdeckung von 75 Prozent soll realisiert werden.”:&nbsp;
          <ExternalLink href="https://www.textilbuendnis.com/" />
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Greenpeace: Konsumkollaps durch Fast Fashion:<br />
          <ExternalLink href="https://www.greenpeace.de/sites/www.greenpeace.de/files/publications/s01951_greenpeace_report_konsumkollaps_fast_fashion.pdf">https://www.greenpeace.de&hellip;konsumkollaps_fast_fashion.pdf</ExternalLink>
        </P>
      </LI>
      <LI>
        <P gapAfter>
          Utopia.de berichtet immer wieder über erschwingliche, attraktive und nachhaltige Mode (und über weitere Themen zu Nachhaltigkeit)<br />
          <ExternalLink href="https://utopia.de/ratgeber/fair-fashion-marken-shops/" />
        </P>
      </LI>
    </UL>

  </Section>
);



// WEBPACK FOOTER //
// ./src/components/LE/MORE_MATERIAL_AND_TIPS.js